import { connect } from 'react-redux'
import { getPostDischarges36mList } from '../actions/actions-postdischarges'
import { getProgramsAssignedToLoginList } from '../actions/actions-programs'
import PostDischarges36m from '../views/PostDischarges/postdischarges36m'
const mapStateToProps = (state, ownProps) => {
  return {
    parentProps: ownProps,
    postdischarges: state.postdischargesR.dataList,
    programsAssigned: state.programsR.programsassignedtologin
  }
}
const mapDispatchToProps = dispatch => {
  return {
    getPostDischarges: loginID => {
      dispatch(getPostDischarges36mList(loginID))
    },
    getProgramsAssignedToLoginList: id => {
      dispatch(getProgramsAssignedToLoginList(id))
    }
  }
}
const PostDischarge36mListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PostDischarges36m)
export default PostDischarge36mListContainer
